import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconCircleArrowRight = ({ color = petrol.main, fill = 'none', ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        className="lucide lucide-circle-arrow-right"
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" fill="none" r="10" />
        <path d="M8 12h8" fill="none" />
        <path d="m12 16 4-4-4-4" fill="none" />
      </svg>
    </SvgIcon>
  );
};

export default IconCircleArrowRight;
